export default __webpack_public_path__ + "static/media/logoMMR.2dbf1bcf.svg";